import { ReactSVG } from 'react-svg';
import Container from '../../components/Container';
import NafathVarificationFunctional from './index.function';
import icons from '../../constants/icons';
import { Button, Text } from '../../components/SecondaryMarket';
import { fontSizes } from '../../constants/constants';
import ViewReverse from '../../components/ViewReverse';
import ViewItems from '../../components/ViewItems';
import CustomInput from '../../components/CustomInput';
import FullScreenLoader from '../../components/FullScreenLoader';

const NafathVarification = () => {
  const { TextWeight, navigate, iqamaNo, setIqamaNo, handleNafathVerification, nafath_loading, handleLogout, getContentKey } = NafathVarificationFunctional();

  return (
    <Container title={getContentKey('new_account_title')} handleLogout={handleLogout}>
      <ViewReverse isResponsive className={'bg-white shadow-light-shadow rounded-xl px-6 py-10'}>
        <div className='flex-1 flex flex-col items-center justify-center'>
          <ViewItems className='w-full md:w-80'>
            <ReactSVG src={icons.nafath_logo_icon} />
            <Text text={getContentKey('nafath_verification')} weight={TextWeight.headingRegular} size={fontSizes.h30} className={'text-dark-blue mt-5 mb-3'} />
            <Text
              text={getContentKey('nafath_approve_request')}
              weight={TextWeight.medium}
              size={fontSizes.h14}
            />

            <CustomInput
              placeholder={getContentKey('iqama_number_placeholder')}
              className={'mt-2'}
              value={iqamaNo}
              onChange={(e) => setIqamaNo(e.target.value)}
              maxLength={10}
            />

            <ViewReverse className={'mt-20 gap-2 w-full'}>
              <Button text={getContentKey('cancel')} className={'bg-transparent border border-grey text-black w-full'} />
              <Button text={getContentKey('continue')} className={'w-full'} onClick={handleNafathVerification} isDisabled={iqamaNo?.length < 10} />
            </ViewReverse>
          </ViewItems>
        </div>
        <ViewItems className={'flex-1 mt-5 md:mt-0 md:px-8'}>
          <Text
            text={getContentKey('required_documents_heading')}
            weight={TextWeight.bold}
            size={fontSizes.h16}
            className={'text-primary-light'}
          />

          <ViewItems className={'gap-4 mt-5 mb-8'}>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text text={getContentKey('authorized_signatory_ids_document')} weight={TextWeight.medium} size={fontSizes.h14} />
            </ViewReverse>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text text={getContentKey('board_of_directors_ids_document')} weight={TextWeight.medium} size={fontSizes.h14} />
            </ViewReverse>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text text={getContentKey('poa_authorization_order_document')} weight={TextWeight.medium} size={fontSizes.h14} />
            </ViewReverse>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text text={getContentKey('commercial_registration_document')} weight={TextWeight.medium} size={fontSizes.h14} />
            </ViewReverse>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text text={getContentKey('memorandum_articles_of_association_document')} weight={TextWeight.medium} size={fontSizes.h14} />
            </ViewReverse>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text text={getContentKey('ministry_license_document')} weight={TextWeight.medium} size={fontSizes.h14} />
            </ViewReverse>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text text={getContentKey('shareholder_resolution_document')} weight={TextWeight.medium} size={fontSizes.h14} />
            </ViewReverse>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text text={getContentKey('fatca_crs_document')} weight={TextWeight.medium} size={fontSizes.h14} />
            </ViewReverse>
          </ViewItems>

          <Text
            text={getContentKey('qualified_investor_documents_heading')}
            weight={TextWeight.bold}
            size={fontSizes.h16}
            className={'text-primary-light'}
          />

          <ViewItems className={'gap-4 mt-5'}>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text
                text={getContentKey('qualified_investor_full_ownership_document')}
                weight={TextWeight.medium}
                size={fontSizes.h14}
              />
            </ViewReverse>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text
                text={getContentKey('qualified_investor_status_document')}
                weight={TextWeight.medium}
                size={fontSizes.h14}
              />
            </ViewReverse>
            <ViewReverse className={'gap-3 items-center'}>
              <ReactSVG src={icons.document_icon} />
              <Text text={getContentKey('company_net_assets_document')} weight={TextWeight.medium} size={fontSizes.h14} />
            </ViewReverse>
          </ViewItems>
        </ViewItems>
      </ViewReverse>


      {nafath_loading && <FullScreenLoader className={"border-t-white"} />}
    </Container>
  );
};

export default NafathVarification;
